import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19ba3456"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container px-0"
}
const _hoisted_2 = {
  class: "table results-table",
  "aria-label": "forecast-result-table-view"
}
const _hoisted_3 = { class: "bg-primary text-color-white py-9" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { id: "empty-cosmetic-header" }, null, -1))
const _hoisted_5 = {
  id: "tonnage-co2e-table-header",
  scope: "colgroup",
  colspan: "2",
  style: {"text-align":"center"}
}
const _hoisted_6 = {
  id: "percentage-distribution-table-header",
  scope: "colgroup",
  colspan: "2",
  style: {"text-align":"center"}
}
const _hoisted_7 = { class: "bg-primary text-color-white py-9" }
const _hoisted_8 = { id: "scopes-category-title-header" }
const _hoisted_9 = {
  id: "tonnage-co2e-first-year-header",
  class: "align-text-right"
}
const _hoisted_10 = {
  id: "tonnage-co2e-last-year-header",
  class: "align-text-right"
}
const _hoisted_11 = {
  id: "percentage-distribution-first-year-header",
  class: "align-text-right"
}
const _hoisted_12 = {
  id: "percentage-distribution-last-year-header",
  class: "align-text-right"
}
const _hoisted_13 = { headers: "scopes-category-title-header" }
const _hoisted_14 = {
  headers: "tonnage-co2e-table-header tonnage-co2e-first-year-header",
  class: "align-text-right"
}
const _hoisted_15 = {
  headers: "tonnage-co2e-table-header tonnage-co2e-last-year-header",
  class: "align-text-right"
}
const _hoisted_16 = {
  headers: "percentage-distribution-table-header percentage-distribution-first-year-header",
  class: "align-text-right"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  headers: "percentage-distribution-table-header percentage-distribution-last-year-header",
  class: "align-text-right"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","height":"350px"}
}
const _hoisted_21 = { style: {"align-self":"center"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "aria-label": "Indlæser",
  class: "spinner"
}, null, -1))
const _hoisted_23 = {
  class: "spinner-status",
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", null, [
      _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.chartheader" })
    ]),
    (_ctx.forecast.calculations.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("th", _hoisted_5, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.table.section1" })
                ]),
                _createElementVNode("th", _hoisted_6, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.table.section2" })
                ])
              ]),
              _createElementVNode("tr", _hoisted_7, [
                _createElementVNode("th", _hoisted_8, [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.resultview.table.header1" })
                ]),
                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.firstYear), 1),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.lastYear), 1),
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.firstYear), 1),
                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.lastYear), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getScopeValues, (scopeValue) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: scopeValue.name,
                  class: _normalizeClass({'bold': scopeValue.name.includes(_ctx.getContentfulString('forecast.resultview.table.total'))})
                }, [
                  _createElementVNode("td", _hoisted_13, _toDisplayString(scopeValue.name), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.doPrettify(scopeValue.valueStart, 2)), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.doForecastPrettify(scopeValue.valueEnd, 2)), 1),
                  _createElementVNode("td", _hoisted_16, [
                    (scopeValue.valuePercentStart)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.doPrettify(scopeValue.valuePercentStart, 2)) + "%", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    (scopeValue.valuePercentEnd)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.doPrettify(scopeValue.valuePercentEnd, 2)) + "%", 1))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_SimpleText, { "text-key": 'forecast.result.scope123.pendingload.table' }, null, 8, ["text-key"])
            ])
          ])
        ]))
  ], 64))
}